<template>
  <div>
    <div class="main-1">
      <div class="content-1"><img src="../../assets/map.png" alt=""></div>
      <div class="content-2">
        <div>{{ zh === 'ja' ? zhJson.content1.ja[0] : zhJson.content1.en[0] }}</div>
        <div style="margin-top: -12px; width: 243px; height: 7px; background: linear-gradient(89.87deg, #3CD3F7 -4.17%, #16F4A7 99.92%), #D9D9D9; border-radius: 27px;"></div>
        <div style="margin-top: 12px">{{ zh === 'ja' ? zhJson.content1.ja[1] : zhJson.content1.en[1] }}</div>
        <div style="margin-top: 10px">{{ zh === 'ja' ? zhJson.content1.ja[2] : zhJson.content1.en[2] }}</div>
      </div>
      <div class="content-3">{{ zh === 'ja' ? zhJson.content1.ja[3] : zhJson.content1.en[3] }}</div>
    </div>
    <div class="main-2">
      <div class="content-1">
        <div class="left"><img src="../../assets/200+.png" alt="" style="width: 93px; height: 25px"></div>
        <div class="right">{{ zh === 'ja' ? zhJson.content2.ja[0] : zhJson.content2.en[0] }}</div>
      </div>
      <div class="content-2" @click="jumpPath('/m/mProducts')"><span>{{ zh === 'ja' ? zhJson.content2.ja[1] : zhJson.content2.en[1] }}</span></div>
    </div>
    <div class="main-3">
      <div class="content-1"><img src="../../assets/machine.png" alt=""></div>
      <div class="content-2"><img src="../../assets/icon-power.png" alt=""></div>
      <div class="content-3">{{ zh === 'ja' ? zhJson.content3.ja[0] : zhJson.content3.en[0] }}</div>
      <div class="content-4">{{ zh === 'ja' ? zhJson.content3.ja[1] : zhJson.content3.en[1] }}</div>
      <div class="content-5">{{ zh === 'ja' ? zhJson.content3.ja[2] : zhJson.content3.en[2] }}<span>{{ zh === 'ja' ? zhJson.content3.ja[3] : zhJson.content3.en[3] }}</span></div>
      <div class="content-6">
        <div class="content-6-1"><img src="../../assets/icon-3-1.png" alt=""></div>
        <div class="content-6-2">{{ zh === 'ja' ? zhJson.content3.ja[4] : zhJson.content3.en[4] }}</div>
        <div class="content-6-3">{{ zh === 'ja' ? zhJson.content3.ja[5] : zhJson.content3.en[5] }}</div>
      </div>
      <div class="content-7">
        <div class="content-7-1"><img src="../../assets/icon-3-2.png" alt=""></div>
        <div class="content-7-2">{{ zh === 'ja' ? zhJson.content3.ja[6] : zhJson.content3.en[6] }}</div>
        <div class="content-7-3">{{ zh === 'ja' ? zhJson.content3.ja[7] : zhJson.content3.en[7] }}</div>
      </div>
    </div>
    <div class="main-4">
<!--      <div class="carousel">-->
<!--        <div @click="carouselToggle('left')"><img src="../../assets/left-arrow.png" alt="" class="arrow"></div>-->
      <div style="position: absolute; z-index: 1; top: 0; left: 0; width: 100%; height: 100%">
        <el-carousel indicator-position="none" :loop="false" :autoplay="false" arrow="never" height="812px" style="width: 100%;" ref="carousel">
          <el-carousel-item v-for="item in carouselList" :key="item.name">
            <div :class="'carousel-bg-' + item.name"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="content-txt">
        <div style="width: 290px; display: flex; flex-direction: column; justify-content: space-between">
          <div class="content-title">
            <div>{{ zh === 'ja' ? zhJson.content4.ja[0] : zhJson.content4.en[0] }}</div>
            <div>{{ zh === 'ja' ? zhJson.content4.ja[1] : zhJson.content4.en[1] }}</div>
            <div style="background: linear-gradient(89.87deg, #25BBDE -4.17%, #11ECA0 99.92%), #FFFFFF;-webkit-background-clip: text;-webkit-text-fill-color: transparent;background-clip: text;text-fill-color: transparent;">{{ zh === 'ja' ? zhJson.content4.ja[2] : zhJson.content4.en[2] }}</div>
            <div>{{ zh === 'ja' ? zhJson.content4.ja[3] : zhJson.content4.en[3] }}</div>
          </div>
          <div class="toggle-group">
            <div @click="carouselToggle('left')"><img src="../../assets/m/left-arrow.png" alt="" class="arrow"></div>
            <div @click="carouselToggle('right')"><img src="../../assets/m/right-arrow.png" alt="" class="arrow"></div>
          </div>
          <div class="content-footer">
            <div class="content-desc">{{ activeName.content }}</div>
            <div class="content-btn" @click="jumpPath('/m/mClients')"><span>{{ zh === 'ja' ? zhJson.content4.ja[4] : zhJson.content4.en[4] }}</span></div>
          </div>
        </div>
      </div>
<!--        <div @click="carouselToggle('right')"><img src="../../assets/right-arrow.png" alt="" class="arrow"></div>-->
<!--      </div>-->
    </div>
    <div class="main-5" id="contact">
      <div class="content-info">
        <div style="display: flex; align-items: center; margin-top: 56px">
          <div class="content-info-1">WHATSAPP</div>
          <div class="content-info-2"></div>
          <div class="content-info-3"><a href="whatsapp://send?phone=+2347038762583">+234 703 876 2583</a></div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <div class="content-info-1">EMAIL</div>
          <div class="content-info-2"></div>
          <div class="content-info-3"><a href="mailto:contact@solarchainlabs.org">contact@solarchainlabs.org</a></div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <div class="content-info-1">{{ zh === 'ja' ? zhJson.content5.ja[0] : zhJson.content5.en[0] }}</div>
          <div class="content-info-2"></div>
          <div class="content-info-3">Solarchain Labs, Km 59, Lekki-Epe Express Way, Sangotedo, Besides UBA, Etiosa East Local Government Area</div>
        </div>
      </div>
      <div style="opacity: 0.3; border: 1px solid #FFFFFF; margin-top: 56px; width: 294px"></div>
      <div @click="jumpPath('/')"><img src="../../assets/logo-w.png" alt="" style="margin-top: 26px; cursor: pointer; width: 138px; height: 16px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mHomePage",
  components: {},
  props: {},
  computed: {},
  watch: {
    "$route.query.zh": {
      immediate: true, // 第一次的数据，也要当做是一种变化
      // 处理函数（不能修改名字） handler('新的值'，'旧的值')
      handler(new_value, old_value) {
        this.zh = new_value;
        if (this.zh === 'ja') {
          this.carouselList = this.carouselJa;
        } else {
          this.carouselList = this.carouselEn;
        }
        this.activeName = this.carouselList[0];
      },
    },
  },
  data() {
    return {
      activeName: null,
      carouselEn: [
        { name: 0, title: 'Grandeur Tech & IT Services, Lagos', content: '‘ Business has never been better with a 24 hour assurance that you can always rely on stable power supply. ’', url: require('../../assets/carousel-1.jpg')},
        { name: 1, title: 'True Vine Hospital', content: '‘ I have saved more than 10,000 naira on fuel every day and you don’t even try to compare it with generators at all. ’', url: require('../../assets/carousel-2.jpg')},
        { name: 2, title: 'Mrs. Ogundoyin', content: '‘ Now, all my friends are using Solarchain Labs and everyone is happy and everyone is enjoying it. You did us a favor. ’', url: require('../../assets/carousel-3.jpg')},
      ],
      carouselJa: [
        { name: 0, title: 'Grandeur Tech & IT Services, Lagos', content: '「 ビジネスは以前に比べて有利になり、24時間安定した電力供給が確保される。 」', url: require('../../assets/carousel-1.jpg')},
        { name: 1, title: 'True Vine Hospital', content: '「 毎日、燃料代で10,000ナイラ以上を節約してきた、発電機と比較しようともしない。 」', url: require('../../assets/carousel-2.jpg')},
        { name: 2, title: 'Mrs. Ogundoyin', content: '「 今、私の友達全員がSolarchain Labsのおかげで、皆幸せで楽しんでいる。 」', url: require('../../assets/carousel-3.jpg')},
      ],
      carouselList: [],
      zh: '',
      zhJson: {
        content1: {
          en: ['Decentralized', 'Energy', 'Infrastructure.', 'Solarchain utilizes blockchain technology to encourage the global adoption of renewable and cost-effective energy solutions for residential and commercial purposes.'],
          ja: ['分散型', 'エネルギー', 'インフラ', 'Solarchainはブロックチェーン技術を活用し、住宅用および商業用の再生可能で費用対効果の高いエネルギーソリューションの世界的な普及を促進している。']
        },
        content2: {
          en: ['Energy Systems...', 'View Details'],
          ja: ['エネルギー・システム...', '詳細']
        },
        content3: {
          en: ['Power.', 'New Way to Gain Power', 'By implementing the Solarchain system in homes and businesses, users can achieve energy independence, eliminating the need for traditional power sources and the associated costs. ',
            'Say goodbye to electricity bills and the bothersome noise generated by generator sets.',
            'Rent to Own', 'Users can gain access to off-grid electricity through the rent-to-own program. After a designated period of rental payments, ownership of the system will be transferred to the user.',
            'Generate to Earn', 'Solarchain energy ledger system will record the energy generation of the ecosystem, and users will have the opportunity to share token rewards associated with their energy generation.'],
          ja: ['エネルギー', '新しいエネルギー取得方法', 'Solarchainシステムを家庭や企業に導入することで、ユーザーはエネルギーの自己供給を実現し、従来の電力供給およびそれに伴う費用を不要にすることができ。',
            '電気料金や発電機からの不快な騒音を排除することもできる。',
            'Rent to Own', 'ユーザーは、Rent to Ownプログラムを通じて、オフグリッド電力を利用することができる。指定された期間のレンタル料支払い後、システムの所有権はユーザーに移行する。',
            'Generate to Earn', 'Solarchainのエネルギー台帳システムは、エコシステムのエネルギー生産量を記録し、ユーザーにエネルギー生産量に関連するトークン報酬を共有する機会を提供する。']
        },
        content4: {
          en: ['What', 'Our', 'Clients', 'Say...', 'More Clients'],
          ja: ['お', '客様', 'の' ,'声...', 'より多くのクライアント']
        },
        content5: {
          en: ['ADDRESS'],
          ja: ['所在地']
        },
      }
    }
  },
  methods: {
    testAxios() {
      this.axios({
        method: 'get',//post
        url: 'api/',
        params: {}//data: {}
      }).then((response) => {
        const result = response.data;
        if (result.code === 0) {
        } else {
        }
      })
    },
    jumpPath(path, id) {
      if (id === 'contact') this.showMenu = false;
      this.$router.push({ path: path, query: {'zh': this.zh, 'id': id} });
    },
    carouselToggle(val) {
      if (val === 'left') {
        if (this.activeName.name === 0) {
          this.activeName = this.carouselList[this.carouselList.length-1];
        } else {
          this.activeName = this.carouselList[this.activeName.name-1];
        }
      }
      if (val === 'right') {
        if (this.activeName.name === this.carouselList.length-1) {
          this.activeName = this.carouselList[0];
        } else {
          this.activeName = this.carouselList[this.activeName.name+1];
        }
      }
      this.$refs.carousel.setActiveItem(this.activeName.name)
    },
  },
  created() {
    this.activeName = this.carouselList[0];
  },
  mounted() {
    if (this.$route.query.id) {
      document.getElementById(this.$route.query.id).scrollIntoView(true);
    }
  }
}
</script>

<style lang="less" scoped>
  .main-1 {
    width: 100%;
    height: 650px;
    //background: url('../../assets/m/bg-1.png') no-repeat center;
    //background-size: cover;
    background: linear-gradient(341.98deg, rgba(255, 255, 255, 0.2) 56.18%, rgba(73, 221, 255, 0.2) 98.84%);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    .content-1 {
      margin-top: 67px;
      img {
        width: 277px;
        height: 249px;
      }
    }
    .content-2 {
      margin-top: 54px;
      width: 299px;
      height: 104px;

      font-family: 'PP Neue Machina',serif;
      font-style: normal;
      //font-weight: 800;
      font-size: 32px;
      line-height: 100%;
      color: #26264C;
    }

    .content-3 {
      margin-top: 28px;
      width: 294px;
      height: 114px;

      font-family: 'Poppins-R',serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      color: #595959;
    }
  }

  .main-2 {
    width: 100%;
    height: 229px;
    background: url('../../assets/m/bg-2.png') no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    .content-1 {
      margin-top: 58px;
      display: flex;
      justify-content: center;
      align-items: center;

      .left {

      }
      .right {
        margin-left: 67px;
        //width: 130px;
        height: 21px;
        cursor: pointer;

        font-family: 'PP Neue Machina',serif;
        font-style: normal;
        //font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        color: #26264C;
      }
    }
    .content-2 {
      margin-top: 23px;
      width: 290px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;

      background: linear-gradient(89.87deg, #25BBDE -4.17%, #11ECA0 99.92%);
      box-shadow: 5px 5px 20px 3px rgba(22, 244, 167, 0.18);
      border-radius: 96px;
      span {
        //width: 76px;
        height: 18px;

        font-family: 'Poppins-SB',serif;
        font-style: normal;
        //font-weight: 600;
        font-size: 12px;
        line-height: 150%;
        color: #FFFFFF;
      }
    }
  }

  .main-3 {
    width: 100%;
    height: 936px;
    background: url('../../assets/m/bg-3.png') no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;

    .content-1 {
      display: flex;
      justify-content: center;
      margin-left: 15px;
      margin-top: -24px;
      img {
        width: 249px;
        height: 263px;
      }
    }
    .content-2 {
      width: 290px;
      margin-top: -60px;
      margin-left: -10px;
      img {
        width: 34px;
        height: 34px;
      }
    }
    .content-3 {
      width: 290px;
      height: 39px;

      font-family: 'PP Neue Machina',serif;
      font-style: normal;
      //font-weight: 800;
      font-size: 36px;
      line-height: 109%;
      color: #FFFFFF;
    }
    .content-4 {
      width: 290px;
      height: 16px;

      font-family: 'Poppins-B',serif;
      font-style: normal;
      //font-weight: 700;
      font-size: 15px;
      line-height: 109%;
      color: #F4F4F4;
      opacity: 0.6;
    }
    .content-5 {
      margin-top: 23px;
      width: 293px;
      height: 144px;

      font-family: 'Poppins-R',serif;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 154%;
      color: #E7E7E7;
      span {
        font-family: 'Poppins-M',serif;
        font-style: normal;
        //font-weight: 500;
        font-size: 12px;
        line-height: 154%;
        letter-spacing: -0.02em;
        background: linear-gradient(180deg, #3CD3F7 7.1%, #16F4A7 88.14%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .content-6 {
      width: 290px;
      height: 183px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      padding-top: 27px;
      padding-left: 21px;

      background: linear-gradient(134.68deg, rgba(115, 115, 121, 0.6) 9.27%, rgba(96, 96, 101, 0.282) 74.86%);
      //opacity: 0.6;
      border-radius: 7px;

      .content-6-1 {
        img {
          width: 22px;
          height: 20px;
        }
      }
      .content-6-2 {
        margin-top: 20px;
        //width: 78px;
        height: 13px;

        font-family: 'Poppins-B',serif;
        font-style: normal;
        //font-weight: 700;
        font-size: 12px;
        line-height: 109%;
        color: #FFFFFF;
      }
      .content-6-3 {
        margin-top: 9px;
        width: 258px;
        height: 102px;

        font-family: 'Poppins-R',serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 154%;
        letter-spacing: -0.04em;
        color: #E7E7E7;
      }
    }
    .content-7 {
      margin-top: 20px;
      width: 290px;
      height: 183px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      padding-top: 27px;
      padding-left: 21px;

      background: linear-gradient(134.68deg, rgba(115, 115, 121, 0.6) 9.27%, rgba(96, 96, 101, 0.282) 74.86%);
      //opacity: 0.6;
      border-radius: 7px;

      .content-7-1 {
        img {
          width: 22px;
          height: 21px;
        }
      }
      .content-7-2 {
        margin-top: 19px;
        //width: 108px;
        height: 13px;

        font-family: 'Poppins-B',serif;
        font-style: normal;
        //font-weight: 700;
        font-size: 12px;
        line-height: 109%;
        color: #FFFFFF;
      }
      .content-7-3 {
        margin-top: 8px;
        width: 249px;
        height: 102px;

        font-family: 'Poppins-R',serif;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 154%;
        letter-spacing: -0.04em;
        color: #E7E7E7;
      }
    }

  }

  .main-4 {
    width: 100%;
    height: 812px;
    position: relative;

    .content-txt {
      width: 100%;
      height: 100%;
      background: rgba(#000000, 0.3);
      position: absolute;
      z-index: 99;
      display: flex;
      justify-content: center;

      font-family: 'Poppins-SB',serif;
      font-style: normal;
      //font-weight: 600;
      font-size: 14px;
      line-height: 142%;
      color: #FFFFFF;

      .content-title {
        margin-top: 53px;
        width: 157px;
        height: 168px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        font-family: 'PP Neue Machina',serif;
        font-style: normal;
        //font-weight: 800;
        font-size: 36px;
        line-height: 100%;
        color: #FFFFFF;
      }

      .toggle-group {
        display: flex;
        justify-content: space-between;
      }

      .arrow {
        width: 8px;
        height: 22px;
        cursor: pointer;
        opacity: 0.8;
      }

      .content-footer {
        margin-bottom: 59px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .content-desc {
          width: 310px;
          height: 83px;

          font-family: 'Poppins-SB',serif;
          font-style: normal;
          //font-weight: 600;
          font-size: 14px;
          line-height: 142%;
          color: #FFFFFF;
        }

        .content-btn {
          margin-top: 20px;
          width: 290px;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;

          background: linear-gradient(89.87deg, #25BBDE -4.17%, #11ECA0 99.92%), #D9D9D9;
          box-shadow: 5px 5px 20px 3px rgba(22, 244, 167, 0.18);
          border-radius: 96px;

          span {
            //width: 78px;
            height: 18px;

            font-family: 'Poppins-SB',serif;
            font-style: normal;
            //font-weight: 600;
            font-size: 12px;
            line-height: 150%;
            color: #FFFFFF;
          }
        }
      }
    }

    .carousel-bg-0 {
      width: 100%;
      height: 100%;
      background: url('../../assets/m/carousel-1.png') no-repeat center;
      background-size: cover;
      //display: flex;
      //justify-content: space-between;
    }
    .carousel-bg-1 {
      width: 100%;
      height: 100%;
      background: url('../../assets/m/carousel-2.png') no-repeat center;
      background-size: cover;
      //display: flex;
      //justify-content: space-between;
    }
    .carousel-bg-2 {
      width: 100%;
      height: 100%;
      background: url('../../assets/m/carousel-3.png') no-repeat center;
      background-size: cover;
      //display: flex;
      //justify-content: space-between;
    }
  }

  .main-5 {
    width: 100%;
    height: 302px;
    background: url('../../assets/m/bg-4.png') no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;

    .content-info {
      width: 294px;
      height: 157px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;

      .content-info-1 {
        width: 70px;
        height: 17px;

        font-family: 'Poppins-B',serif;
        font-style: normal;
        //font-weight: 700;
        font-size: 12px;
        line-height: 142%;
        color: #FFFFFF;
      }
      .content-info-2 {
        margin-left: 20px;
        margin-right: 20px;
        border-right: 1px solid #FFFFFF;
        height: 10px;
        opacity: 0.3;
      }
      .content-info-3 {
        width: 177px;
        height: 17px;

        font-family: 'Poppins-M',serif;
        font-style: normal;
        //font-weight: 500;
        font-size: 12px;
        line-height: 142%;
        color: #FFFFFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/m/homePage.vue